import './index.css';


export const ShortButton = ({loading,text,style,click}) => {
    return ( <div></div>)
    // return ( 
        
    //     style == 1 ? (
    //         <button className="custom__shortbutton" 
    //         style={{backgroundColor:"#C4D4CC",color:"#476355"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#476355" size={28} />
    //           </>: text}</button>)
    //     : style == 2 ? (
    //         <button className="custom__shortbutton" 
    //         style={{backgroundColor:"#D9D3D7",color:"#634b5a"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#634b5a" size={28} />
    //           </>: text}</button>)
    //     : style == 3 ? (
    //         <button className="custom__shortbutton" 
    //         style={{backgroundColor:"#ccd4dc",color:"#3f4e61"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#3f4e61" size={28} />
    //           </>: text}</button>)
    //     : null

    //  );
}
 
export const RegularButton = ({loading,text,style,click}) => {
    return (<div></div>)
    // return ( 
        
    //     style == 1 ? (
    //         <button className="custom__regularbutton" 
    //         style={{backgroundColor:"#C4D4CC",color:"#476355"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#476355" size={28} />
    //           </>: text}
    //           </button>)
    //     : style == 2 ? (
    //         <button className="custom__regularbutton" 
    //         style={{backgroundColor:"#D9D3D7",color:"#634b5a"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#634b5a" size={28} />
    //           </>: text}</button>)
    //     : style == 3 ? (
    //         <button className="custom__regularbutton" 
    //         style={{backgroundColor:"#ccd4dc",color:"#3f4e61"}} onClick={click} disabled={loading ? true : false}>
    //         {
    //             loading ? <>
    //             <ClipLoader color="#3f4e61" size={28} />
    //           </>: text}</button>)
    //     : null
    
            
    //  );
}
 
// export default Button;